import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Loading from '../general/Loading.js';
import '../css/components/ViewParty.css';

const ViewParty = ({setResponse}) => {
  const navigate = useNavigate();
    const [item, setItem] = useState([]);
    const [selectedProduct, setSelectedProduct] = useState('');
    const [showDelete, setShowDelete] = useState(false);
        const [loading, setLoading] = useState(false);
        const [searchQuery, setSearchQuery] = useState('');
    const [partyType, setPartyType] = useState('Party');

    useEffect(() => {
        const fetchProducts = async () => {
            setLoading(true);
            try {
                const response = await fetch('https://api.siddhabhairabistore.com/get-all-party');

                if (response.ok) {
                    const data = await response.json();
                    setItem(data);
                    setLoading(false);
                } else {
                    setLoading(false);
                    console.error('Failed to fetch users');
                }
            } catch (error) {
                setLoading(false);
                console.error('Error fetching data:', error);
            }
        };

        fetchProducts();
    }, []);


const filterProduct = item.filter(myItem =>
  myItem.p_type === partyType &&
  (
    myItem.name?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    myItem.mobile?.toLowerCase().includes(searchQuery.toLowerCase()) ||
    myItem.email?.toLowerCase().includes(searchQuery.toLowerCase())
  )
);

    const handleShowDelete = (product) => {
      setSelectedProduct(product);
      setShowDelete(true);
    }

      const handleDelete = async (productId) => {
    try {
      const response = await fetch(`https://api.siddhabhairabistore.com/delete-party/${productId}`, {
        method: 'DELETE',
      });

      if (response.ok) {
setItem((prevProducts) => prevProducts.filter((product) => product.id !== productId));
        setResponse({ message: 'Party deleted successfully!', status: 'success' });
        setTimeout(() => {
          setResponse('');
        }, 2000);
        setShowDelete(false);
      } else {
                setResponse({ message: 'Unable to Delete Party.', status: 'error' });
        setTimeout(() => {
          setResponse('');
        }, 2000);  
      }
    } catch (error) {
      console.error('Error deleting product:', error);
    }
  };


  return (
    <>
    <section className='my-4'>
      <div className='px-4'>
        <div className='d-flex justify-content-between'>
          <p className='page-title'>View Party</p>
          <button className='edit-btn' onClick={() => navigate('/add-party')}>Add Party</button>
        </div>

<div className='row my-3'>

  <div className='col-lg-9'>
                    <div className='d-flex bg-white rounded-2 pt-3 pb-2'>
                        <i class="fa-solid fa-magnifying-glass text-darkblue px-2"></i>
                        <input
                            type="text"
                            className="profile-control rounded-2 border-0 bg-white w-100 py-0"
                            placeholder="Search by name, mobile, email"
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                        />
                        
                        
                    </div>
</div>



<div className='col-lg-3'>
  <select
    className="border-0 profile-control"
    value={partyType}
    onChange={(e) => setPartyType(e.target.value)}
  >
    <option value="Party">Party</option>
    <option value="Customer">Customer</option>
  </select>
</div>


</div>



<div className='table-responsive bg-white p-3'>
  <table className='w-100'>

<tr className='inventory-row'>
  <th className='py-2'>S No</th>
  <th className='py-2'>Name</th>
  <th className='py-2'>Mobile</th>
  <th className='py-2'>Email</th>
  <th className='py-2'>Address</th>
  <th className='py-2'>GSTIN</th>
  <th className='py-2'>Action</th>
</tr>


              {filterProduct.map((product, idx) => (
                <tr className='inventory-row'>
                  <td className='py-2'>{idx + 1}</td>
                  <td className='py-2'>{product.name}</td>
                  <td className='py-2'>{product.mobile}</td>
                  <td className='py-2'>{product.email}</td>
                  <td className='py-2'>{product.address} {product.city} {product.state} {product.pincode}</td>
                  <td className='py-2'>{product.gst != null || product.gst != '' ? product.gst : ''}</td>
                  <td className='py-2'>
                     <span className='edit-btn p-2' onClick={() => navigate('/edit-party', { state: { party: product } })}>&nbsp;&nbsp;Edit <i class="fa-solid fa-pen-to-square"></i>&nbsp;&nbsp;&nbsp;</span>
<span className='ms-2 close-btn p-2' onClick={() => handleShowDelete(product)}>Remove <i class="fa-solid fa-xmark"></i></span>    

                  </td>
                </tr>



              ))}
                                </table>
</div>



      </div>
    </section>

{showDelete && (
  <>
                                  <section className="detail-dialog animate__animated animate__zoomIn px-2">
                                    <div className='detail-dialog-inner text-center col-lg-4 col-11 mx-auto px-lg-5 py-lg-5 px-3 py-3'>

<p className='page-title fs-6'>Want to Remove '{selectedProduct.name}'?</p>

<button className='edit-btn' onClick={() => handleDelete(selectedProduct.id)}>Yes</button>&nbsp;&nbsp;
<button className='close-btn' onClick={() => setShowDelete(false)}>No</button>

</div>
</section>
  </>
)}

            {loading && <Loading setLoading={setLoading} />}
            </>
);
};

export default ViewParty;
